import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth, homeForRole } from "../lib/auth";
import { Spinner } from "../components/states";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = loc.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid, role: "USER" });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const after = sessionStorage.getItem("rav3_after_login"); sessionStorage.removeItem("rav3_after_login");
        nav(after || homeForRole(data.user.role), { replace: true });
      } catch { nav("/login"); }
    })();
  }, [loc.hash, nav, setUser]);

  return <Spinner label="Completing sign-in" />;
}
